import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import * as styles from "./info-callout.module.css";

const variantMap = {
    information: {
        wrapperVariant: styles.infoCalloutInformation,
        iconName: "info-circle" as const,
    },
    error: {
        wrapperVariant: styles.infoCalloutError,
        iconName: "error-circle" as const,
    },
    success: {
        wrapperVariant: styles.infoCalloutSuccess,
        iconName: "success-circle" as const,
    },
};

interface InfoCalloutProps {
    className?: string;
    variant: keyof typeof variantMap;
    title: string;
    dataTestId?: string;
}

export function InfoCallout({
    className,
    title,
    variant,
    dataTestId,
}: InfoCalloutProps): React.ReactElement {
    const currentVariant = variantMap[variant] || variantMap.information;

    return (
        <div
            className={clsx(styles.infoCallout, currentVariant.wrapperVariant, className)}
            data-testid={dataTestId}
            id="info-callout-stack"
        >
            <div className={clsx(styles.iconWrapper)}>
                <SVGIcon name={currentVariant.iconName} />
            </div>
            <Text textStyle={"body-s"}>{title}</Text>
        </div>
    );
}
